export default __webpack_public_path__ + "static/media/eco-icon-grey.80a8d9e6.svg";